(function () {
    'use strict';

    angular.module('doclr.instellingen', ['doclr.praktijk', 'doclr.resources.api'])
        .config(function ($stateProvider) {
            $stateProvider
                .state('praktijk-instellingen', {
                    url: '/instellingen/praktijk',
                    templateUrl: '/partials/instellingen/praktijk.html',
                    resolve: {
                        praktijk: function (Praktijk, praktijkContext) {
                            return Praktijk.getInfo(praktijkContext.id);
                        }
                    },
                    controller: function ($scope, $state, praktijk, Praktijk, praktijkContext
                        , notificationService, $uibModal, userContext) {
                        $scope.praktijk = praktijk;
                        $scope.userContext = userContext;
                        $scope.standaardAdres = praktijk.adressen.filter(function (adres) {
                            return adres.standaard;
                        })[0];

                        praktijk.copyAdres = function (vanAdres, naarAdres) {
                            naarAdres.locatieNaam = vanAdres.locatieNaam;
                            naarAdres.straat = vanAdres.straat;
                            naarAdres.nummer = vanAdres.nummer;
                            naarAdres.bus = vanAdres.bus;
                            naarAdres.postcode = vanAdres.postcode;
                            naarAdres.gemeente = vanAdres.gemeente;
                            naarAdres.telefoon = vanAdres.telefoon;
                            naarAdres.thumbnailUrl = vanAdres.thumbnailUrl;
                        };

                        $scope.bewaren = function () {
                            Praktijk.wijzigPraktijk($scope.praktijk).then(function () {
                                var praktijkId = praktijkContext.id; // TODO: fix praktijkcontext id is id zonder /api/praktijk/... en $scope.praktijk.id heeft dit wel
                                angular.extend(praktijkContext, $scope.praktijk);
                                praktijkContext.id = praktijkId;
                                notificationService.showSuccess(doclrVertaal.instant('instellingen.wijzigpraktijk.succes'));
                                $state.go('agenda.initial');
                            });
                        };

                        $scope.wijzigAdres = function (adres) {
                            $uibModal.open({
                                templateUrl: '/partials/instellingen/wijzigadres.html',
                                controller: function ($scope, $uibModalInstance) {
                                    var updateAdres = {};
                                    praktijk.copyAdres(adres, updateAdres);
                                    $scope.adres = updateAdres;
                                    $scope.hideCloseButton = true;
                                    $scope.titel = 'Adres wijzigen';
                                    $scope.onOk = function () {
                                        praktijk.copyAdres(updateAdres, adres);
                                        $uibModalInstance.close();
                                    };
                                },
                                backdrop: 'static'
                            });
                        };

                        $scope.adresToevoegen = function () {
                            $uibModal.open({
                                templateUrl: '/partials/instellingen/wijzigadres.html',
                                controller: function ($scope, $uibModalInstance) {
                                    var updateAdres = {
                                        locatieNaam: '',
                                        straat: '',
                                        nummer: '',
                                        gemeente: '',
                                        postcode: '',
                                        bus: '',
                                        thumbnailUrl: '',
                                        volgorde: praktijk.adressen.length + 1
                                    };

                                    $scope.adres = updateAdres;
                                    $scope.hideCloseButton = true;
                                    $scope.titel = 'Adres toevoegen';

                                    $scope.onOk = function () {
                                        praktijk.adressen.push(updateAdres);
                                        $uibModalInstance.close();
                                    };
                                },
                                backdrop: 'static'
                            });
                        };

                        $scope.zetAlsStandaard = function (adres) {
                            praktijk.adressen.forEach(function (adr) {
                                adr.standaard = false;
                            });
                            adres.standaard = true;
                            $scope.standaardAdres = adres;
                        };

                        $scope.verwijderAdres = function (adres) {

                            if (adres.standaard) {
                                notificationService.showWarning(doclrVertaal.instant('instellingen.verwijder.adres.warning'));
                                return;
                            }

                            function toonVerwijderModal() {
                                $scope.confirmmodal = {
                                    title: doclrVertaal.instant('instellingen.verwijder.adres.confirmmodal.title'),
                                    question: doclrVertaal.instant('instellingen.verwijder.adres.confirmmodal.question')
                                };

                                var modalInstance = $uibModal.open({
                                    templateUrl: '/partials/components/confirmmodal.html',
                                    scope: $scope
                                });

                                modalInstance.result.then(function () {
                                    praktijk.adressen.splice(praktijk.adressen.indexOf(adres), 1);
                                });
                            }

                            if (adres.id) {
                                Praktijk.listTypeBeschikbaarheidVoorAdres(praktijkContext.id, adres.id).then(function (typeBeschikbaarheden) {
                                    if (typeBeschikbaarheden.length === 0) {
                                        toonVerwijderModal();
                                    } else {
                                        var typesString = typeBeschikbaarheden.map(function (x) {
                                            return x.naam;
                                        }).join(',');
                                        notificationService.showWarning(doclrVertaal.instant('instellingen.verwijder.adres.confirmmodal.question') + typesString);
                                    }
                                });
                            } else {
                                toonVerwijderModal();
                            }
                        };

                        $scope.terug = function () {
                            $state.go('agenda.initial');
                        };
                    }
                })
                .state('agenda-instellingen', {
                    url: '/instellingen/agendas/:agenda',
                    resolve: {
                        agendas: function (AgendaOverzicht, praktijkContext) {
                            return AgendaOverzicht.get(praktijkContext.id);
                        },
                        selectedAgenda: function (agendas, $stateParams) {
                            return $stateParams.agenda ? agendas.findAgendaVoorId(decodeURIComponent($stateParams.agenda)) : agendas[0];
                        },
                        iCalendarUri: function (Praktijk, selectedAgenda) {
                            return Praktijk.getICalendarUri(selectedAgenda.id).then(function (uri) {
                                return uri.iCalendarUri;
                            });
                        },
                        disciplineList: function (Disciplines) {
                            return Disciplines.getList();
                        },
                        praktijk: function (Praktijk, praktijkContext) {
                            return Praktijk.getInfo(praktijkContext.id);
                        }
                    },
                    views: {
                        '': {
                            templateUrl: '/partials/components/page.with.sidebar.html'
                        },
                        'content@agenda-instellingen': {
                            templateUrl: '/partials/instellingen/agendalijst.html',
                            controller: function ($scope, $state, agendas, selectedAgenda, notificationService, praktijk, Praktijk, praktijkContext, iCalendarUri, disciplineList, $location) {
                                $scope.praktijkContext = praktijkContext;
                                $scope.selectedAgenda = selectedAgenda;
                                $scope.iCalendarUri = iCalendarUri;
                                $scope.disciplineList = disciplineList;
                                $scope.praktijk = praktijk;

                                if (selectedAgenda) {
                                    var fullUrl = $location.$$absUrl;
                                    var startOfAdmin = fullUrl.indexOf('admin#');
                                    $scope.urlBase = fullUrl.substr(0, startOfAdmin);
                                    $scope.urlAgendaVoorPatient = $scope.urlBase +
                                        'patient#!?agenda=' + selectedAgenda.volgnummer;
                                }

                                $scope.bewaren = function () {
                                    Praktijk.wijzigAgenda($scope.selectedAgenda).then(function () {
                                        notificationService.showSuccess(doclrVertaal.instant('instellingen.wijzig.agenda.succes'));
                                    });
                                };
                                $scope.gaNaarTeleInstellingen = function () {
                                    $state.go('richtlijnen-telesecretariaat', {agenda: encodeURIComponent($scope.selectedAgenda.id)});
                                };
                            }
                        },
                        'sidebar@agenda-instellingen': {
                            templateUrl: '/partials/instellingen/agendalijst.sidebar.html',
                            controller: function ($scope, $state, agendas, selectedAgenda) {
                                $scope.agendas = agendas;
                                $scope.selectedAgenda = selectedAgenda;

                                $scope.wijzigAgenda = function (data) {
                                    $state.go('.', {agenda: encodeURIComponent(data.agenda.id)});
                                };
                            }
                        }
                    }
                })
                .state('richtlijnen-telesecretariaat', {
                    url: '/instellingen/richtlijnen/:agenda',
                    resolve: {
                        agendas: function (AgendaOverzicht, praktijkContext) {
                            return AgendaOverzicht.get(praktijkContext.id);
                        },
                        selectedAgenda: function (agendas, $stateParams) {
                            return $stateParams.agenda ? agendas.findAgendaVoorId(decodeURIComponent($stateParams.agenda)) : agendas[0];
                        },
                        richtlijnenInfo: function (RichtlijnenTelesecretariaat, selectedAgenda, praktijkContext) {
                            return RichtlijnenTelesecretariaat.getInfo(praktijkContext.id, selectedAgenda.uuid);
                        }
                    },
                    views: {
                        '': {
                            templateUrl: '/partials/components/page.with.sidebar.html'
                        },
                        'content@richtlijnen-telesecretariaat': {
                            templateUrl: '/partials/instellingen/richtlijnen.telesecretariaat.html',
                            controller: function ($scope, $state, agendas, selectedAgenda, notificationService, Praktijk, praktijkContext, richtlijnenInfo) {
                                $scope.praktijkContext = praktijkContext;
                                $scope.selectedAgenda = selectedAgenda;
                                $scope.richtlijnenInfo = richtlijnenInfo;

                                $scope.bewaren = function () {
                                    richtlijnenInfo.wijzigRichtlijnen($scope.praktijkContext.id, $scope.selectedAgenda.id, $scope.richtlijnenInfo).then(function () {
                                        notificationService.showSuccess(doclrVertaal.instant('instellingen.wijzig.telsec.richtlijnen.succes'));
                                    });
                                };
                            }
                        },
                        'sidebar@richtlijnen-telesecretariaat': {
                            templateUrl: '/partials/instellingen/agendalijst.sidebar.html',
                            controller: function ($scope, $state, agendas, selectedAgenda) {
                                $scope.agendas = agendas;
                                $scope.selectedAgenda = selectedAgenda;

                                $scope.wijzigAgenda = function (data) {
                                    $state.go('.', {agenda: encodeURIComponent(data.agenda.id)});
                                };
                            }
                        }
                    }
                })
                .state('links-instellingen', {
                    url: '/instellingen/links',
                    templateUrl: '/partials/instellingen/links.html',
                    controller: function ($scope, praktijkContext, omgevingUri, DisciplinesApi, burgerUri, adminUri) {
                        $scope.praktijkContext = praktijkContext;
                        $scope.omgevingUri = omgevingUri;
                        $scope.burgerUri = burgerUri;
                        $scope.adminUri = adminUri;

                    }
                });
        });
})();